/**
 * Created by idea on 20/03/2017.
 */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
// import { ApiService } from './Api.service';
// import { ApiIcheckService } from './ApiIcheck.service';
import { User } from '../models/User';
// import { GoogleLoginProvider } from '../providers/googleLoginProvider';
import { IAuthenticate } from '../contracts/Authenticate.contract';
import { UserToken } from '../models/UserToken';
import { ApiEvsService } from './ApiEvs.service';
import { Router } from '@angular/router';
import { SocketService } from './Socket.service';
import { ChatService } from './Chat.service';

declare const PromiseWindow: any;

@Injectable()
export class AuthenticateService {
  public user: User;
  private facebook: IAuthenticate;
  public icheck_token: string;

  // private google: IAuthenticate;

  constructor(private router: Router, private apiEvs: ApiEvsService, 
    private socketService : SocketService,
    private chatService : ChatService
    ) {
    // this.facebook = new FacebookLoginProvider(environment.facebook, {scope: 'email, public_profile'});
    // this.google = new GoogleLoginProvider(environment.google);
  }

  public load() {

  }

  
  login(body: any) {
    let url = `/login`;
    if (body.rememberMe === true) {
      body.ttl_in_second = 999999999999999999999999999;
    }
    let login = this.apiEvs.login(url, body);
    
    console.log(body)
    setTimeout(() => {
      if (!login) {
        this.router.navigate['/'];
        console.log('reload');
      }
    }, 500)
    return login.map(
      (res: any) => {
        let data = res.data;
        // localStorage.setItem('data', JSON.stringify(data) );
        // remove
        localStorage.removeItem('Access-Token');
        localStorage.removeItem('Access-Token-Icheck');
        localStorage.removeItem('User');
        localStorage.removeItem('FireBase-Token');
        // save
        localStorage.setItem('Access-Token', data.token);
        localStorage.setItem('FireBase-Token', data.token_firebase);
        if (body.provider === 'facebook') {
          localStorage.setItem('Access-Token-Icheck', this.icheck_token);
        } else {
          localStorage.setItem('Access-Token-Icheck', data.token_icheck);
        }
        localStorage.setItem('Token-Expire', data.ttl);
        const expiresAt = JSON.stringify((data.ttl * 1000) + Date.now());
        localStorage.setItem('expires_at', expiresAt);
        localStorage.setItem('status', '1');
        console.log(data);
        if (data.info && data.user_id) {
          data.info.user_id_evs = data.user_id;
          data.info.tenant_id = data.info.tenant_id ? data.info.tenant_id : data.tenant_id;
          localStorage.setItem('User', JSON.stringify(data.info));
        }
        let user: any = {};
       
        return data;
      }
    );

  }

  

  register(body: any) {
    // let url = 'http://sandbox.icheck.com.vn:5266/register';
    let url = '/register';
    return this.apiEvs.post(url, body)
  }

  logout() {
    let user = JSON.parse(localStorage.getItem('User'));
    // this.chatService.monitor({
    //   event : 'agent_logout',
    //   id: user._id,
    //   tenant_id: user.tenant_id
    // })

    // this.chatService.monitor({
    //   event : 'agent_offline_web',
    //   id: user._id,
    //   tenant_id: user.tenant_id
    // })
    localStorage.clear();
    // try{
    //   this.socketService.logout();
    // }catch(e) {
    //   console.log('loi logout',e);
    // }
    this.router.navigate(['/login']);
    // localStorage.removeItem('Access-Token');
    // localStorage.removeItem('isShop');
    // localStorage.removeItem('FireBase-Token');
    // localStorage.removeItem('Access-Token-Icheck');
  }


}



// WEBPACK FOOTER //
// G:/3csoft/client-final/src/app/common/services/Authenticate.service.ts